import dayjs from 'dayjs'
import { NOTIFICATION_DAY_GROUPS } from './notification-center.const'

function resolveDayGroup(ts, now) {
  const day = dayjs(ts)
  if (day.isSame(now, 'day')) return NOTIFICATION_DAY_GROUPS.TODAY
  if (day.isSame(now.subtract(1, 'day'), 'day')) return NOTIFICATION_DAY_GROUPS.YESTERDAY
  return NOTIFICATION_DAY_GROUPS.EARLIER
}

/**
 * Groups notifications (already sorted newest first) into Today / Yesterday / Earlier, skipping empty groups.
 * @param {Array<{ ts: string }>} notifications
 * @param {import('dayjs').Dayjs} [now]
 * @returns {Array<{ id: string, items: Array<object> }>}
 */
export function groupNotificationsByDay(notifications, now = dayjs()) {
  const groups = Object.values(NOTIFICATION_DAY_GROUPS).map(id => ({ id, items: [] }))
  const byId = Object.fromEntries(groups.map(group => [group.id, group]))
  ;(notifications ?? []).forEach(notification => {
    byId[resolveDayGroup(notification.ts, now)].items.push(notification)
  })
  return groups.filter(group => group.items.length > 0)
}
